export default customElements.define('w-investment-theme', class InvestmentTheme extends wealthify.CustomElementBaseClass {

    constructor () {
        const styleSelector = 'c-investment-theme';
        const config = {
            styleSelector,
            templateHTML: `
                <w-fancy-radio-list shape="rectangle" data-root>
                    <p class="${styleSelector}__introduction" data-introduction></p>
                    <w-modal heading="Our Investment Themes" data-modal>
                        <p>We have two main investment themes for you to choose from:</p>
                        <w-accordion-item key="theme-accordion-1" titleprop="Original Theme">
                            <p>Wealthify's Original Plans use low-cost investment funds that let you hold a wide range of investment types, such as shares, bonds, property and commodities (such as precious metals, energy and agriculture).</p>
                            <p>Your money is invested all across the world and in a wide number of sectors, this works to reduce the level of risk that you're exposed to when investing.
                            Our team of experts carefully choose funds from leading providers to build our five Original Plans.</p>
                        </w-accordion-item>
                        <w-accordion-item key="theme-accordion-2" titleprop="Ethical Theme">
                            <p>Wealthify's Ethical Plans work much in the same way as our Original Plan, except that they aim to exclude industries and activities that are considered harmful to society and the environment. This means that your money won't support industries such as tobacco, gambling, deforestation, and companies who adopt unfair labour practices.</p>
                            <p>We invest in organisations committed to making a positive impact through their environmental, social and governance (ESG) practices, so you can invest in a sustainable way.</p>
                            <p>Our ethical fund managers regularly monitor the activities of the companies they invest in and can use their shareholder influence to maintain and raise ethical standards.</p>
                        </w-accordion-item>
                        <w-video srcprop="https://www.youtube.com/embed/mfunudstEtk" external="true"></w-video>
                    </w-modal>
                </w-fancy-radio-list>`,
            cacheDom: [ 'data-introduction', 'data-modal' ]
        };

        super(config);

        this.dom.root.items = this._getDefaultItems();
        this.dom.root.buttondata = this._getDefaultButtonData();

        this.addEventListener('valuechange', () => {
            this.value = this.dom.root.value;
            this.valid = this.dom.root.valid;
            this.nameValue = this._getSelectedTheme();
        });

        this.onConnectedCallback = () => {
            this.style.display = 'block';
        };
    }

    static defaultHeading = 'Choose an investment theme';
    static defaultIntroduction = 'You can select between original and ethical.';
    static defaultKey = 'Theme';

    static get observedProps () {

        return [
            new wealthify.Prop('heading', {default: this.defaultHeading}),
            new wealthify.Prop('headinglarge', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('introduction', {default: this.defaultIntroduction}),
            new wealthify.Prop('key', {default: this.defaultKey}),
            new wealthify.Prop('selected', {
                default: 0,
                type: wealthify.propTypes.Number(),
                validators: [wealthify.propValidators.IsPositiveNumber()]
            }),
            new wealthify.Prop('simplified', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            wealthify.props.DarkMode()
        ];
    }

    get propCallbacks () {
        return {
            heading: () => {
                this.dom.root.titleprop = this.heading;
            },
            headinglarge: () => {
                this.dom.root.headinglarge = this.headinglarge;
            },
            introduction: (value) => {
                this.dom.introduction.innerHTML = value;
            },
            key: () => {
                this.dom.root.key = this.key;
            },
            selected: (value) => this.dom.root.selected = value,
            simplified: (value) => {
                const classListAction = value ? 'add' : 'remove';
                const buttonData = value ? {} : this._getDefaultButtonData();

                this.dom.introduction.classList[classListAction]('u-display__none');
                this.dom.root.buttondata = buttonData;
            },
        };
    }

    _getDefaultItems () {
        return [
            {
                name: 'Original',
                label: '<p class="u-text__weight--bold">Original</p>Our classic blend of investments from the UK and overseas.',
                value: wealthify.enums.theme.Original,
            },
            {
                name: 'Ethical',
                label: '<p class="u-text__weight--bold">Ethical</p>A blend of environmentally and socially responsible investments.',
                value: wealthify.enums.theme.Ethical,
            }
        ];
    }

    _getDefaultButtonData () {
        return {
            label: 'More about our themes',
            onclickprop: (() => {
                this.dom.modal.open = true;
            }).bind(this)
        };
    }

    _getSelectedTheme () {
        return this.value ? this._getDefaultItems()[this.value].name : null;
    }

});